import Vue from 'vue'
import ability from './ability'

// เดิมใช้ abilitiesPlugin จาก @casl/vue ซึ่งให้ 3 อย่าง: $ability, $can() และ <Can>
// แอปนี้ใช้แค่ $ability — ไม่มีการเรียก $can() และไม่มี <Can> สักจุด
// @casl/vue ตัวที่รองรับ @casl/ability 6 ต้องใช้ Vue 3 จึงถอดออกแล้วผูก $ability ตรง ๆ
Object.defineProperty(Vue.prototype, '$ability', { value: ability })
